import React, { useEffect } from "react";
import ImageCard from "../../../components/card/ImageCard";
import AllButton from "../../../components/button/AllButton";
import { Link, useParams } from "react-router-dom";
import GalleryService from "../../../services/gallery";
import { useState } from "react";
import timeFunction from "../../../functions/getTime";
import Lightbox from "../../../components/gallery/Lightbox";

export default function GalleryDetail() {
  let [galleryData, setGalleryData] = useState([]);
  let [anotherGalleryData, setAnotherGalleryData] = useState([]);
  // รูปที่กำลังเปิดดูเต็มจอ (index) — null คือปิด
  let [openImage, setOpenImage] = useState(null);
  let { slug, lang } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
    getGalleryData();
    getAnotherGalleryData();
    // eslint-disable-next-line
  }, []);

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`/th`, "_self");
    }
  });

  const getGalleryData = async () => {
    try {
      let res = await GalleryService.getGalleryBySlug(`${slug}`);

      if (res[0]) {
        setGalleryData(res[0]);
      } else {
        window.open(
          `/${lang}/gallery`,
          "_self"
        );
      }
    } catch {
      console.error();
    }
  };

  const getAnotherGalleryData = async () => {
    try {
      let res = await GalleryService.getAnotherGallery(`${slug}`);

      if (res) {
        setAnotherGalleryData(res);
      }
    } catch {
      console.error();
    }
  };

  const bannerName = () => {
    if (galleryData && galleryData.title) {
      return [
        { name: "Gallery", href: "/gallery" },
        {
          name:
            lang === "th"
              ? galleryData?.title?.detail_TH
              : galleryData?.title?.detail_EN,
        },
      ];
    }
    return []; // return an empty array if the condition is not met
  };

  return (
    <div className="service-info pt-[135px] lg:pt-[0px]">
      <div className="section">
        <div className="page-container">
          {/* บริการ แยก */}
          <div className="mt-[92px] mb-[300px]">
            <p className="text-body font-medium text-left">
              <a href={`/${lang}`} className="cursor-pointer">
                หน้าหลัก
              </a>
              {bannerName() &&
                bannerName().map((item, i) => (
                  <span
                    key={i}
                    className="capitalize cursor-pointer"
                    onClick={() => {
                      if (
                        item.href &&
                        window.location.pathname !== `/${lang}${item.href}`
                      ) {
                        window.open(
                          `/${lang}${item.href}`,
                          "_self"
                        );
                      }
                    }}
                  >
                    {" "}
                    / {item.name}
                  </span>
                ))}
            </p>

            {galleryData.title && (
              <h1 className="text-heading font-bold text-slateGray text-left mt-[25px]">
                {lang === "th"
                  ? galleryData.title.detail_TH
                  : galleryData.title.detail_EN}
              </h1>
            )}

            <div className="mt-[10px] flex items-center gap-[30px]">
              <p className="text-body font-medium text-left">
                {timeFunction.getTime(galleryData.date, lang)}
              </p>
              {galleryData?.publisher && (
                <div className="flex justify-center items-center gap-[12px]">
                  <div>
                    <div className="rounded-full w-[10px] h-[10px] xl:w-[14px] xl:h-[14px] bg-lightGray" />
                  </div>
                  <p className="text-body font-medium text-left">
                    {lang === "th"
                      ? galleryData?.publisher.detail_TH
                      : galleryData?.publisher.detail_EN}
                  </p>
                </div>
              )}
            </div>

            <div className="mt-[10px] flex gap-[16px]">
              <p className="text-small font-medium text-left text-blue">
                {galleryData?.tag?.map((item, i) => (
                  <span key={i}>
                    <>
                      <span
                        className="cursor-pointer text-blue hover:underline"
                        onClick={() => {
                          window.open(
                            `/${lang}/search/${item.tag}`,
                            "_self"
                          );
                        }}
                      >
                        #{item.tag}
                      </span>
                      {i + 1 < galleryData?.tag?.length && ", "}
                    </>
                  </span>
                ))}
              </p>
            </div>

            <div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[35px] mt-[55px] mb-[120px]">
                {galleryData?.image?.image.map((item, i) => (
                  <span key={i}>
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => setOpenImage(i)}
                      onKeyDown={(e) => e.key === "Enter" && setOpenImage(i)}
                      className="w-full rounded-[12px] bg-lightGray h-[240px] !bg-cover !bg-center cursor-pointer hover:opacity-90 transition-opacity"
                      style={
                        item
                          ? {
                              background: `url(${process.env.REACT_APP_API_URL}${item.url})`,
                            }
                          : { background: `#D9D9D9` }
                      }
                    />
                  </span>
                ))}
              </div>

              {openImage !== null && galleryData?.image?.image && (
                <Lightbox
                  images={galleryData.image.image}
                  index={openImage}
                  lang={lang}
                  onClose={() => setOpenImage(null)}
                  onChange={setOpenImage}
                />
              )}

              <hr className="my-[36px] h-[2px] w-full bg-darkGray" />

              <div>
                <div className="flex justify-between">
                  <h1 className="text-heading font-bold text-slateGray text-left">
                    ประมวลภาพกิจกรรมอื่นๆ
                  </h1>
                  <Link to={`/${lang}/gallery`}>
                    <AllButton lang={lang} />
                  </Link>
                </div>

                <div
                  id="image-activity"
                  className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 lg:flex-row gap-[30px] mt-[68px]"
                >
                  {anotherGalleryData &&
                    anotherGalleryData
                      .slice(0, 3)
                      .map((item, i) => (
                        <ImageCard data={item} key={i} lang={lang} />
                      ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
